<script>
const INTERVALL = 1000;
const COUNTER_SET_TIME = 5;

export default {
  name: 'Countdown',

  props: {
    intervall: {
      type: Number,
      default: INTERVALL,
    },
    counterSetTime: {
      type: Number,
      default: COUNTER_SET_TIME,
    },
  },

  data() {
    return {
      counterTime: 0,
    };
  },

  computed: {
    indicatorPercentage() {
      return this.counterTime / this.counterSetTime - 1;
    },
  },

  mounted() {
    this.initCounter();
  },

  methods: {
    initCounter() {
      const counterIntervall = setInterval(() => {
        this.counterTime++;
        if (this.counterTime === this.counterSetTime) this.$emit('countdownFinished');
      }, this.intervall);

      this.$once('hook:beforeDestroy', () => {
        clearInterval(counterIntervall);
      });
    },

    skipCountdown() {
      if (process.env.NODE_ENV !== 'production') this.counterTime = this.counterSetTime - 1;
    },
  },

  render() {
    return this.$scopedSlots.default({
      indicatorPercentage: this.indicatorPercentage,
      skipCountdown: this.skipCountdown,
    });
  },
};
</script>
